<template>
    <div>
        <Modal
            v-model="mainTable.sarchCardShow"
            title="搜索条件"
            :width="1000"
            footer-hide
        >
            <search-card
                :form="mainTable.searchForm"
                :table-load-event="getSaleStatList"
                :table-search="mainTable.tableSearch"
                ref="searchCard"
            />
        </Modal>
        <Card>
            <Row :gutter="16">
                <Col span="24">
                    <div class="global-tool-bar">
                        <div class="left-bar">
                            <span class="title">销售统计(发货单)</span>
                            <span style="margin-left: 10px">统计时间:</span>
                            <DatePicker
                                type="daterange"
                                v-model="selectDates"
                                size="small"
                                transfer
                                :clearable="false"
                                placement="bottom-end"
                                placeholder="选择期初和期末时间"
                                style="margin-left: 4px; width: 180px"
                                @on-change="onDateChange"
                            ></DatePicker>
                            <span style="margin-left: 10px">会员类别:</span>
                            <RadioGroup
                                v-model="userType"
                                style="margin-left: 10px; width: 210px"
                                @on-change="onUserTypeChange"
                            >
                                <Radio label="F"> <span>外部会员</span></Radio>
                                <Radio label="E"> <span>内部会员</span></Radio>
                            </RadioGroup>
                            <span style="margin-left: 10px; font-size: 12px"
                                >是否0价单:</span
                            >
                            <RadioGroup
                                v-model="totalOrderCost"
                                style="margin-left: 10px; width: 120px"
                                @on-change="onTotalOrderCostChange"
                            >
                                <Radio label="0"> <span>否</span></Radio>
                                <Radio label="1"> <span>是</span></Radio>
                            </RadioGroup>
                            <RadioGroup
                                v-model="groupBy"
                                style="margin-left: 10px"
                                type="button"
                                size="small"
                                @on-change="onGroupByChange"
                            >
                                <Radio label="seedFarm">
                                    <span>苗场</span>
                                </Radio>
                                <Radio label="manager">
                                    <span>经理</span>
                                </Radio>
                                <Radio label="station">
                                    <span>转运站</span>
                                </Radio>
                                <Radio label="product">
                                    <span>商品</span>
                                </Radio>
                                <Radio label="member">
                                    <span>会员</span>
                                </Radio>
                                <Radio label="mainCate">
                                    <span>大类</span>
                                </Radio>
                                <Radio label="subCate">
                                    <span>小类</span>
                                </Radio>
                                <Radio label="province">
                                    <span>省</span>
                                </Radio>
                                <Radio label="city">
                                    <span>市</span>
                                </Radio>
                                <Radio label="dist">
                                    <span>区</span>
                                </Radio>
                            </RadioGroup>
                        </div>
                        <div class="right-bar">
                            <Button
                                type="info"
                                size="small"
                                class="btns"
                                shape="circle"
                                icon="ios-send"
                                @click="onExport()"
                                >导出</Button
                            >
                            <Button
                                type="primary"
                                size="small"
                                class="btns"
                                shape="circle"
                                icon="ios-search"
                                @click="
                                    mainTable.sarchCardShow =
                                        !mainTable.sarchCardShow
                                "
                                >搜索</Button
                            >
                        </div>
                    </div>
                </Col>
            </Row>
            <!-- <Row>
                <div class="tag-filter-container">
                    <div
                        v-for="(tagInfo, tagKey) in tagTypes"
                        :key="tagKey"
                        class="tag-filter-item"
                    >
                        <CustomTag
                            :label="tagInfo.label"
                            :value="tagInfo.value"
                            :search-value="tagInfo.searchValue"
                            :is-active="!!(tagInfo.showInput || (tagInfo.value && tagInfo.value.trim()))"
                            :show-input="tagInfo.showInput"
                            :placeholder="tagInfo.placeholder"
                            :closable="true"
                            :mode="tagInfo.mode"
                            :options="tagInfo.options"
                            @click="handleTagClick(tagKey)"
                            @input-blur="(value) => handleTagInputBlur(tagKey, value)"
                            @close="onRemoveTagByKey(tagKey)"
                        />
                    </div>
                </div>
            </Row> -->
            <div style="margin-top: 10px">
                <Row :gutter="16">
                    <Col span="24">
                        <stand-pagination-table
                            :columns="mainTable.statColumns"
                            :data="mainTable.data"
                            :loading="mainTable.loading"
                            :table-search="mainTable.tableSearch"
                            :extHeight="-50"
                            :table-load-event="getSaleStatList"
                            :showPage="false"
                        />
                    </Col>
                </Row>
            </div>

        </Card>

        <Modal
            v-model="combineStatDetail.show"
            title="销售明细"
            :width="1200"
            :closable="false"
            footer-hide
        >
            <Card :padding="0" :bordered="false" :dis-hover="true">
                <Row :gutter="16">
                    <Col span="24">
                        <div class="global-tool-bar">
                            <div class="left-bar">
                                <span class="title">销售明细列表</span>
                            </div>
                            <div class="right-bar">
                                <!-- <Checkbox v-model="combineStatDetail.showZeroPriceOnly"
				            	@on-change="onshowZeroPrice">只看零价商品</Checkbox> -->
                                <Button
                                    type="info"
                                    size="small"
                                    class="btns"
                                    shape="circle"
                                    icon="ios-send"
                                    @click="onDetailExport()"
                                    >导出</Button
                                >
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row :gutter="16">
                    <Col span="24">
                        <stand-pagination-table
                            :columns="combineStatDetail.preSaleColumns"
                            :data="combineStatDetail.preSaleData"
                            :loading="combineStatDetail.loading"
                            :table-search="combineStatDetail.tableSearch"
                            :table-load-event="showCombineStatDetail"
                            :autoHeight="true"
                            :showPage="true"
                        />
                    </Col>
                </Row>
            </Card>
            <div slot="header" class="div-header">
                <Button class="btn-font" type="text" @click="cancal">✕</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import SearchCard from "@/components/searchCard/searchCard.vue";
import search from "@/libs/search";
import StandPaginationTable from "@/components/standard-pagination-table/StandPaginationTable";
import CustomTag from "@/components/custom-tag/CustomTag.vue";
import { dateTimeRender, dateRender } from "@/libs/tableRowTimeRender";
import {
    numberToFixed,
    number2ThousandsFormat
} from "@/components/number-input/display-format";
import { getThisMonthStart, getTodayDateString } from "@/libs/logic";
import {
    getPreSaleStat,
    getCombineSaleStat,
    getCombineSaleStatDetail
} from "@/api/modules/sale-management/sale-stat";
import { getRegionCascade } from "@/api/modules/system-management/region-management";
import { DOWNLOAD_SERVER } from "@/api/modules/files";
import { getSeedFarmList } from "@/api/modules/system-management/seedFarm-management";
import { getCustomerManagerUserList } from "@/api/modules/account-management/customerManager-user-management";
import { getDistributionStationList } from "@/api/modules/system-management/distributionStation-management";
import { getProductList } from "@/api/modules/product-management/product-management";
import { getExternalCustomerUserList } from "@/api/modules/account-management/externalCustomer-user-management";
export default {
    name: "sale-stat-list",
    components: {
        StandPaginationTable,
        SearchCard,
        CustomTag
    },
    data() {
        return {
            userType: "F",
            totalOrderCost: "",
            groupBy: "seedFarm",
            selectDates: [],
            allRegions: [],
            filterTags: [],
            seedFarmList: [],
            tagTypes: {},
            mainTable: {
                statColumns: [],
                data: [],
                sarchCardShow: false,
                searchForm: [],
                loading: false,
                tableSearch: search.getSearchParams()
            },
            combineStatDetail: {
                uuid: "",
                show: false,
                loading: false,
                showZeroPriceOnly: false,
                preSaleData: [],
                tableLoading: false,
                tableSearch: search.getSearchParams(),
                preSaleColumns: [
                    {
                        title: "定金单编号",
                        key: "depositBillRecordCode",
                        width: 160,
                        align: "center",
                        excel: true
                    },
                    {
                        title: "发货单编号",
                        key: "preSaleDeliveryRecordCode",
                        width: 160,
                        align: "center",
                        excel: true
                    },
                    {
                        title: "苗场编号",
                        key: "seedFarmCode",
                        width: 80,
                        align: "center",
                        excel: true
                    },
                    {
                        title: "苗场名称",
                        key: "seedFarmName",
                        width: 100,
                        align: "center",
                        excel: true
                    },
                    {
                        title: "客户名称",
                        key: "orderOwerPersonName",
                        width: 80,
                        align: "center",
                        excel: true
                    },
                    {
                        title: "客户账号",
                        key: "orderOwner",
                        width: 60,
                        align: "center",
                        excel: true
                    },
                    {
                        title: "客户电话",
                        key: "orderOwnerPhone",
                        width: 100,
                        align: "center",
                        excel: true
                    },
                    {
                        title: "区域",
                        key: "regionName",
                        width: 100,
                        align: "center",
                        excel: true
                    },
                    {
                        title: "已付定金",
                        key: "depositDue",
                        width: 80,
                        align: "center",
                        excel: true
                    },
                    {
                        title: "下单时间",
                        key: "preSaleDeliveryRecordCreateAt",
                        width: 130,
                        align: "center",
                        render: (h, params) =>
                            dateTimeRender(
                                h,
                                params.row.preSaleDeliveryRecordCreateAt
                            ),
                        excel: true
                    },
                    {
                        title: "商品编号",
                        key: "productCode",
                        width: 60,
                        align: "center",
                        excel: true
                    },
                    {
                        title: "商品名称",
                        key: "productName",
                        width: 100,
                        align: "center",
                        excel: true
                    },
                    {
                        title: "单位",
                        key: "unitName",
                        width: 60,
                        align: "center",
                        excel: true
                    },
                    {
                        title: "大类",
                        key: "mainCategoryName",
                        width: 100,
                        align: "center",
                        excel: true
                    },
                    {
                        title: "小类",
                        key: "subCategoryName",
                        width: 100,
                        align: "center",
                        excel: true
                    },
                    {
                        title: "周次",
                        key: "weekSeq",
                        width: 60,
                        align: "center",
                        excel: true
                    },
                    {
                        title: "单价",
                        key: "preSaleDeliveryDetailActProductPrice",
                        width: 60,
                        align: "center",
                        excel: true
                    },
                    {
                        title: "本批发货量",
                        key: "preSaleDeliveryDetailQuantity",
                        width: 80,
                        align: "center",
                        excel: true
                    },
                    {
                        title: "实际发货量",
                        key: "receiveQuantity",
                        width: 80,
                        align: "center",
                        excel: true
                    },
                    {
                        title: "销售金额",
                        key: "preSaleDeliveryDetailActProductCost",
                        width: 80,
                        align: "center",
                        excel: true
                    },
                    {
                        title: "均价",
                        key: "avgPrice",
                        width: 80,
                        align: "center",
                        render: (h, params) => {
                            const avgPrice = params.row.avgPrice || 0;
                            return h("div", {}, [
                                h(
                                    "span",
                                    {},
                                    number2ThousandsFormat(avgPrice, 2, "")
                                )
                            ]);
                        },
                        excel: true
                    },
                    {
                        title: "优惠金额",
                        key: "saleDiscountValue",
                        width: 80,
                        align: "center",
                        excel: true,
                        render: (h, params) => {
                            const saleDiscountValue = params.row
                                .saleDiscountValue
                                ? params.row.saleDiscountValue
                                : 0;
                            return h("div", {}, [
                                h(
                                    "span",
                                    {},
                                    number2ThousandsFormat(
                                        saleDiscountValue,
                                        3,
                                        ""
                                    )
                                )
                            ]);
                        }
                    },
                    {
                        title: "代金券",
                        key: "voucherAmount",
                        width: 80,
                        align: "center",
                        excel: true,
                        render: (h, params) => {
                            const voucherAmount = params.row.voucherAmount
                                ? params.row.voucherAmount
                                : 0;
                            return h("div", {}, [
                                h(
                                    "span",
                                    {},
                                    number2ThousandsFormat(voucherAmount, 3, "")
                                )
                            ]);
                        }
                    },
                    {
                        title: "退货金额",
                        key: "refundTotalVal",
                        width: 80,
                        align: "center",
                        excel: true
                    },
                    {
                        title: "有效金额",
                        key: "saleRealValue",
                        width: 80,
                        align: "center",
                        excel: true,
                        render: (h, params) => {
                            const saleRealValue = params.row.saleRealValue
                                ? params.row.saleRealValue
                                : 0;
                            return h("div", {}, [
                                h(
                                    "span",
                                    {},
                                    number2ThousandsFormat(saleRealValue , 3, "")
                                )
                            ]);
                        }
                    },
                    {
                        title: "经理",
                        key: "managerName",
                        width: 80,
                        align: "center",
                        excel: true
                    },
                    {
                        title: "经理提成",
                        key: "depositBillDetailsalesAssociateCommissionValue",
                        width: 80,
                        align: "center",
                        excel: true
                    },
                    {
                        title: "转运站",
                        key: "distributionStationName",
                        width: 80,
                        align: "center",
                        excel: true
                    },
                    {
                        title: "苗场发货",
                        key: "preSaleDeliveryRecordDeliveryDate",
                        width: 80,
                        align: "center",
                        render: (h, params) =>
                            dateRender(
                                h,
                                params.row.preSaleDeliveryRecordDeliveryDate
                            ),
                        excel: true
                    },
                    {
                        title: "转运站发货",
                        key: "stationDeliveryDate",
                        width: 80,
                        align: "center",
                        render: (h, params) =>
                            dateRender(h, params.row.stationDeliveryDate),
                        excel: true
                    }
                ]
            }
        };
    },
    // props: {
    //     userType: { type: String, default: 'F' }
    // },
    created() {
        // 初始化tagTypes配置
        this.initTagTypes();
    },
    mounted() {
        let beginDate = this.getThisMonthStart();
        let endDate = this.getTodayDateString();
        this.selectDates = [beginDate, endDate];
        this.getAllRegionList();
        this.init();
        this.getSeedFarmList();
        this.getCustomerManagerUserList();
        this.getDistributionStationList();
        this.getProductList();
        this.getExternalCustomerUserList();
    },
    methods: {
        /**
         * 高精度加法函数 - 解决浮点数精度问题
         * @param {number} a - 被加数
         * @param {number} b - 加数
         * @param {number} precision - 精度位数，默认3位
         * @returns {number} 精确相加结果
         */
        preciseAdd(a, b, precision = 3) {
            const multiplier = Math.pow(10, precision);
            return (Math.round(a * multiplier) + Math.round(b * multiplier)) / multiplier;
        },
        /**
         * 初始化tagTypes配置
         * @param {Array} seedFarmOptions - 苗场选项数据
         */
        initTagTypes(seedFarmOptions = [], customerManagerOptions = [], distributionStationOptions=[]) {
            const tagTypesConfig = {
                "seedFarmUuid": {
                    label: "苗场",
                    placeholder: "输入苗场编号",
                    selected: false,
                    showInput: false,
                    value: "",
                    searchValue: "",
                    mode: "select",
                    options: Array.isArray(seedFarmOptions) ? seedFarmOptions : []
                },
                "userSec.userUuid": {
                    label: "经理",
                    placeholder: "输入客户经理经理编号",
                    selected: false,
                    showInput: false,
                    value: "",
                    searchValue: "",
                    mode: "select",
                    options: Array.isArray(customerManagerOptions) ? customerManagerOptions : []
                },
                "distributionStationUuid": {
                    label: "转运站",
                    placeholder: "输入转运站编号",
                    selected: false,
                    showInput: false,
                    value: "",
                    searchValue: "",
                    mode: "select",
                    options: Array.isArray(distributionStationOptions) ? distributionStationOptions : []
                },
                "products.productUuid": {
                    label: "商品",
                    placeholder: "输入产品标号",
                    selected: false,
                    showInput: false,
                    value: "",
                    searchValue: "",
                    mode: "select",
                    options: []
                },
                "users.userUuid": {
                    label: "会员",
                    placeholder: "输入会员编号",
                    selected: false,
                    showInput: false,
                    value: "",
                    searchValue: "",
                    mode: "select",
                    options: []
                },
                "mainCategories.mainCategoryName": {
                    label: "大类",
                    placeholder: "输入大类名称",
                    selected: false,
                    showInput: false,
                    value: "",
                    searchValue: "",
                    mode: "input"
                },
                "subCategories.subCategoryName": {
                    label: "小类",
                    placeholder: "输入小类名称",
                    selected: false,
                    showInput: false,
                    value: "",
                    searchValue: "",
                    mode: "input"
                },
                "region1.regionName": {
                    label: "省",
                    placeholder: "输入省份名称",
                    selected: false,
                    showInput: false,
                    value: "",
                    searchValue: "",
                    mode: "input"
                },
                "region2.regionName": {
                    label: "市",
                    placeholder: "输入城市名称",
                    selected: false,
                    showInput: false,
                    value: "",
                    searchValue: "",
                    mode: "input"
                },
                "region3.regionName": {
                    label: "区",
                    placeholder: "输入区县名称",
                    selected: false,
                    showInput: false,
                    value: "",
                    searchValue: "",
                    mode: "input"
                },
                "products.productColor": {
                    label: "颜色",
                    placeholder: "请输入颜色",
                    selected: false,
                    showInput: false,
                    value: "",
                    searchValue: "",
                    mode: "input"
                }
            };

            // 使用Vue.set确保响应式更新
            this.$set(this, 'tagTypes', tagTypesConfig);
        },

        getSeedFarmList() {
            let tempSearch = search.getSearchParams({
                closeAllConditions: true
            });
            getSeedFarmList(tempSearch).then(res => {
                if (res.code == 0 && res.data) {
                    // 格式化苗场数据为选项格式
                    const formattedOptions = this.formatSeedFarmOptions(res.data.records);
                    // 安全地更新tagTypes中的seedFarmUuid.options
                    const currentSeedFarmUuid = this.tagTypes.seedFarmUuid || {};
                    this.$set(this.tagTypes, 'seedFarmUuid', {
                        ...currentSeedFarmUuid,
                        options: formattedOptions
                    });
                    console.log('苗场数据已更新:', formattedOptions);
                }
                else {
                    console.error('获取苗场列表失败:', res);
                    this.seedFarmList = [];
                    // 安全地更新空的选项数组
                    const currentSeedFarmUuid = this.tagTypes.seedFarmUuid || {};
                    this.$set(this.tagTypes, 'seedFarmUuid', {
                        ...currentSeedFarmUuid,
                        options: []
                    });
                }
            }).catch(err => {
                console.error('获取苗场列表异常:', err);
                this.seedFarmList = [];
                // 安全地处理异常情况
                const currentSeedFarmUuid = this.tagTypes.seedFarmUuid || {};
                this.$set(this.tagTypes, 'seedFarmUuid', {
                    ...currentSeedFarmUuid,
                    options: []
                });
            });
        },
        getCustomerManagerUserList(){
            let tempSearch = search.getSearchParams({
                closeAllConditions: true
            });
            getCustomerManagerUserList(tempSearch).then(res => {
                if (res.code == 0 && res.data) {
                    const formattedOptions = this.formatCustomerManagerOptions(res.data.records);
                    // 直接更新tagTypes中的"userSec.userUuid"选项
                    const currentUserSecUserUuid = this.tagTypes["userSec.userUuid"] || {};
                    this.$set(this.tagTypes, 'userSec.userUuid', {
                        ...currentUserSecUserUuid,
                        options: formattedOptions
                    });
                    console.log('客户经理数据已更新:', formattedOptions);
                } else {
                    console.error('获取客户经理列表失败:', res);
                    // 安全地更新空的选项数组
                    const currentUserSecUserUuid = this.tagTypes["userSec.userUuid"] || {};
                    this.$set(this.tagTypes, 'userSec.uUerUuide', {
                        ...currentUserSecUserUuid,
                        options: []
                    });
                }
            }).catch(err => {
                console.error('获取客户经理列表异常:', err);
                // 安全地处理异常情况
                const currentUserSecUserName = this.tagTypes["userSec.userUuid"] || {};
                this.$set(this.tagTypes, 'userSec.userUuid', {
                    ...currentUserSecUserName,
                    options: []
                });
            });
        },
        getDistributionStationList(){
            let tempSearch = search.getSearchParams({
                closeAllConditions: true
            });
            getDistributionStationList(tempSearch).then(res => {
                if (res.code == 0 && res.data) {
                    // 格式化转运站数据为选项格式
                    const formattedOptions = this.formatStationOptions(res.data.records);
                    // 安全地更新tagTypes中的DistributionStationUuid.options
                    const currentDistributionStationUuid = this.tagTypes.distributionStationUuid || {};
                    this.$set(this.tagTypes, 'distributionStationUuid', {
                        ...currentDistributionStationUuid,
                        options: formattedOptions
                    });
                    console.log('转运站数据已更新:', formattedOptions);
                }
                else {
                    console.error('获取转运站列表失败:', res);
                    // 安全地更新空的选项数组
                    const currentDistributionStationUuid = this.tagTypes.distributionStationUuid || {};
                    this.$set(this.tagTypes, 'distributionStationUuid', {
                        ...currentDistributionStationUuid,
                        options: []
                    });
                }
            }).catch(err => {
                console.error('获取转运站列表异常:', err);
                // 安全地处理异常情况
                const currentDistributionStationUuid = this.tagTypes.distributionStationCode || {};
                this.$set(this.tagTypes, 'distributionStationUuid', {
                    ...currentDistributionStationUuid,
                    options: []
                });
            });
        },

        /**
         * 格式化苗场数据为选项数组格式
         * @param {Array} seedFarmList - 苗场数据数组
         * @returns {Array} 格式化后的选项数组
         */
        formatSeedFarmOptions(list = []) {
            if (!Array.isArray(list)) return [];

            return list.map(item => {
                const { seedFarmUuid, seedFarmCode, seedFarmName } = item || {};

                // 没有唯一值就直接丢弃，防止下拉出现空选项
                if (!seedFarmUuid) return null;

                const label = seedFarmName
                    ? `${seedFarmCode}-${seedFarmName}`
                    : seedFarmCode || '未知场站';

                return { value: String(seedFarmUuid), label };
            }).filter(Boolean);   // 去掉可能的 null
        },

        /**
       * 格式化客户经理数据为选项数组格式
       * @param {Array} list - 客户经理数据数组
       * @returns {Array} 格式化后的选项数组
       */
        formatCustomerManagerOptions(list = []){
            if (!Array.isArray(list)) return [];

            return list.map((item, index) => {
                // 安全数据访问，确保item是对象
                if (!item || typeof item !== 'object') {
                    console.warn(`Invalid customer manager item at index ${index}:`, item);
                    return null;
                }

                const { userCustomerManagerLoginUuid, userCustomerManagerCode, userCustomerManagerName } = item;

                // 没有唯一值就直接丢弃，防止下拉出现空选项
                if (!userCustomerManagerLoginUuid) return null;

                const label = userCustomerManagerName
                    ? `${userCustomerManagerCode || ''}-${userCustomerManagerName}`
                    : userCustomerManagerCode || '未知客户经理';

                return { value: String(userCustomerManagerLoginUuid), label };
            }).filter(Boolean);
        },
        /**
         * 格式化转运站数据为选项数组格式
         * @param {Array} list - 转运站数据数组
         * @returns {Array} 格式化后的选项数组
         */
        formatStationOptions(list = []) {
            if (!Array.isArray(list)) return [];

            return list.map((item, index) => {
                // 安全数据访问，确保item是对象
                if (!item || typeof item !== 'object') {
                    console.warn(`Invalid distribution station item at index ${index}:`, item);
                    return null;
                }

                const { distributionStationUuid, distributionStationCode, distributionStationName } = item;

                // 没有唯一值就直接丢弃，防止下拉出现空选项
                if (!distributionStationUuid) return null;

                const label = distributionStationName
                    ? `${distributionStationCode || ''}-${distributionStationName}`
                    : distributionStationCode || '未知转运站';

                return { value: String(distributionStationUuid), label };
            }).filter(Boolean);
        },
        getProductList(){
            let tempSearch = search.getSearchParams({
                closeAllConditions: true
            });
            getProductList(tempSearch).then(res => {
                if (res.code == 0 && res.data) {
                    // 格式化商品数据为选项格式
                    const formattedOptions = this.formatProductOptions(res.data.records);
                    // 安全地更新tagTypes中的products.productUuid.options
                    const currentProductsProductCode = this.tagTypes["products.productUuid"] || {};
                    this.$set(this.tagTypes, 'products.productUuid', {
                        ...currentProductsProductCode,
                        options: formattedOptions
                    });
                    console.log('商品数据已更新:', formattedOptions);
                }
                else {
                    console.error('获取商品列表失败:', res);
                    // 安全地更新空的选项数组
                    const currentProductsProductCode = this.tagTypes["products.productUuid"] || {};
                    this.$set(this.tagTypes, 'products.productUuid', {
                        ...currentProductsProductCode,
                        options: []
                    });
                }
            }).catch(err => {
                console.error('获取商品列表异常:', err);
                // 安全地处理异常情况
                const currentProductsProductCode = this.tagTypes["products.productUuid"] || {};
                this.$set(this.tagTypes, 'products.productUuid', {
                    ...currentProductsProductCode,
                    options: []
                });
            });
        },

        /**
         * 格式化商品数据为选项数组格式
         * @param {Array} list - 商品数据数组
         * @returns {Array} 格式化后的选项数组
         */
        formatProductOptions(list = []) {
            if (!Array.isArray(list)) return [];

            return list.map((item, index) => {
                // 安全数据访问，确保item是对象
                if (!item || typeof item !== 'object') {
                    console.warn(`Invalid product item at index ${index}:`, item);
                    return null;
                }

                const { productUuid, productCode, productName } = item;

                // 没有唯一值就直接丢弃，防止下拉出现空选项
                if (!productUuid) return null;

                const label = productName
                    ? `${productCode || ''}-${productName}`
                    : productCode || '未知商品';

                return { value: String(productUuid), label };
            }).filter(Boolean);
        },
        getExternalCustomerUserList(){
            let tempSearch = search.getSearchParams({
                closeAllConditions: true
            });
            getExternalCustomerUserList(tempSearch).then(res => {
                if (res.code == 0 && res.data) {
                    // 格式化会员数据为选项格式
                    const formattedOptions = this.formatExternalCustomerUserOptions(res.data.records);
                    // 安全地更新tagTypes中的users.userUuid.options
                    const currentUsersUserName = this.tagTypes["users.userUuid"] || {};
                    this.$set(this.tagTypes, 'users.userUuid', {
                        ...currentUsersUserName,
                        options: formattedOptions
                    });
                    console.log('会员数据已更新:', formattedOptions);
                }
                else {
                    console.error('获取会员列表失败:', res);
                    // 安全地更新空的选项数组
                    const currentUsersUserName = this.tagTypes["users.userUuid"] || {};
                    this.$set(this.tagTypes, 'users.userUuid', {
                        ...currentUsersUserName,
                        options: []
                    });
                }
            }).catch(err => {
                console.error('获取会员列表异常:', err);
                // 安全地处理异常情况
                const currentUsersUserName = this.tagTypes["users.userUuid"] || {};
                this.$set(this.tagTypes, 'users.userUuid', {
                    ...currentUsersUserName,
                    options: []
                });
            });
        },

        /**
         * 格式化会员数据为选项数组格式
         * @param {Array} list - 会员数据数组
         * @returns {Array} 格式化后的选项数组
         */
        formatExternalCustomerUserOptions(list = []) {
            if (!Array.isArray(list)) return [];

            return list.map((item, index) => {
                // 安全数据访问，确保item是对象
                if (!item || typeof item !== 'object') {
                    console.warn(`Invalid external customer user item at index ${index}:`, item);
                    return null;
                }

                const { userExternalCustomerLoginUuid, userName, userExternalCustomerName } = item;

                // 没有唯一值就直接丢弃，防止下拉出现空选项
                if (!userExternalCustomerLoginUuid) return null;

                const label = userExternalCustomerName
                    ? `${userName || ''}-${userExternalCustomerName}`
                    : userName || '未知会员';

                return { value: String(userExternalCustomerLoginUuid), label };
            }).filter(Boolean);
        },
        reSetColumns() {
            if (
                this.groupBy == "product"
                || this.groupBy == "mainCate"
                || this.groupBy == "subCate"
            ) {
                this.mainTable.statColumns = [
                    { title: "统计项", key: "groupName", align: "center" },
                    {
                        title: "本批发货量",
                        key: "preSaleCount",
                        align: "center"
                    },
                    {
                        title: "实际发货量",
                        key: "totalReceiveCount",
                        align: "center"
                    },
                    {
                        title: "销售金额",
                        key: "preSaleValue",
                        align: "center",
                        width: 120,
                        render: (h, params) => {
                            const preSaleValue = params.row.preSaleValue
                                ? params.row.preSaleValue
                                : 0;
                            return h("div", {}, [
                                h(
                                    "span",
                                    {},
                                    number2ThousandsFormat(preSaleValue, 2, "")
                                )
                            ]);
                        }
                    },
                    {
                        title: "优惠金额",
                        key: "saleDiscountValue",
                        align: "center",
                        render: (h, params) => {
                            const saleDiscountValue = params.row
                                .saleDiscountValue
                                ? params.row.saleDiscountValue
                                : 0;
                            return h("div", {}, [
                                h(
                                    "span",
                                    {},
                                    number2ThousandsFormat(
                                        saleDiscountValue,
                                        2,
                                        ""
                                    )
                                )
                            ]);
                        }
                    },
                    {
                        title: "代金券",
                        key: "totalVoucherAmount",
                        align: "center",
                        render: (h, params) => {
                            const totalVoucherAmount = params.row.totalVoucherAmount
                                ? params.row.totalVoucherAmount
                                : 0;
                            return h("div", {}, [
                                h(
                                    "span",
                                    {},
                                    number2ThousandsFormat(
                                        totalVoucherAmount,
                                        2,
                                        ""
                                    )
                                )
                            ]);
                        }
                    },
                    {
                        title: "退货金额",
                        key: "refundTotalVal",
                        align: "center",
                        render: (h, params) => {
                            const refundTotalVal = params.row.refundTotalVal
                                ? params.row.refundTotalVal
                                : 0;
                            return h("div", {}, [
                                h(
                                    "span",
                                    {},
                                    number2ThousandsFormat(
                                        refundTotalVal,
                                        2,
                                        ""
                                    )
                                )
                            ]);
                        }
                    },
                    {
                        title: "有效金额",
                        key: "saleRealValue",
                        align: "center",
                        render: (h, params) => {
                            const saleRealValue = params.row.saleRealValue
                                ? params.row.saleRealValue
                                : 0;
                            return h("div", {}, [
                                h(
                                    "span",
                                    {},
                                    number2ThousandsFormat(saleRealValue, 2, "")
                                )
                            ]);
                        }
                    },
                    {
                        title: "均价",
                        key: "avgPrice",
                        align: "center",
                        render: (h, params) => {
                            const avgPrice = params.row.avgPrice || 0;
                            return h("div", {}, [
                                h(
                                    "span",
                                    {},
                                    number2ThousandsFormat(avgPrice, 2, "")
                                )
                            ]);
                        }
                    },
                    {
                        title: "销售定金",
                        key: "combinDeposit",
                        align: "center",
                        render: (h, params) => {
                            const combinDeposit = params.row.combinDeposit
                                ? params.row.combinDeposit
                                : 0;
                            return h("div", {}, [
                                h(
                                    "span",
                                    {},
                                    number2ThousandsFormat(combinDeposit, 2, "")
                                )
                            ]);
                        }
                    },
                    {
                        title: "客户经理提成",
                        key: "commissionValue",
                        align: "center",
                        render: (h, params) => {
                            const commissionValue = params.row.commissionValue
                                ? params.row.commissionValue
                                : 0;
                            return h("div", {}, [
                                h(
                                    "span",
                                    {},
                                    number2ThousandsFormat(
                                        commissionValue,
                                        2,
                                        ""
                                    )
                                )
                            ]);
                        }
                    },
                    {
                        title: "操作",
                        key: "action",
                        align: "center",
                        width: 250,
                        render: (h, params) => {
                            if (params.row.action === -1) {
                                return "";
                            }
                            else {
                                return h("div", [
                                    h(
                                        "Button",
                                        {
                                            props: {
                                                type: "text",
                                                size: "small",
                                                shape: "circle"
                                            },
                                            on: {
                                                click: () => {
                                                    this.showCombineStatDetail(
                                                        params.row.uuid
                                                    );
                                                }
                                            }
                                        },
                                        "查看明细"
                                    )
                                ]);
                            }
                        }
                    }
                ];
            }
            else if (this.groupBy == "manager") {
                this.mainTable.statColumns = [
                    { title: "统计项", key: "groupName", align: "center" },
                    {
                        title: "部门名称",
                        key: "projectName",
                        align: "center"
                    },
                    {
                        title: "本批发货量",
                        key: "preSaleCount",
                        align: "center"
                    },
                    {
                        title: "实际发货量",
                        key: "totalReceiveCount",
                        align: "center"
                    },
                    {
                        title: "销售金额",
                        key: "preSaleValue",
                        align: "center",
                        width: 120,
                        render: (h, params) => {
                            const preSaleValue = params.row.preSaleValue
                                ? params.row.preSaleValue
                                : 0;
                            return h("div", {}, [
                                h(
                                    "span",
                                    {},
                                    number2ThousandsFormat(preSaleValue, 2, "")
                                )
                            ]);
                        }
                    },
                    {
                        title: "优惠金额",
                        key: "saleDiscountValue",
                        align: "center",
                        render: (h, params) => {
                            const saleDiscountValue = params.row
                                .saleDiscountValue
                                ? params.row.saleDiscountValue
                                : 0;
                            return h("div", {}, [
                                h(
                                    "span",
                                    {},
                                    number2ThousandsFormat(
                                        saleDiscountValue,
                                        2,
                                        ""
                                    )
                                )
                            ]);
                        }
                    },
                    {
                        title: "代金券",
                        key: "totalVoucherAmount",
                        align: "center",
                        render: (h, params) => {
                            const totalVoucherAmount = params.row.totalVoucherAmount
                                ? params.row.totalVoucherAmount
                                : 0;
                            return h("div", {}, [
                                h(
                                    "span",
                                    {},
                                    number2ThousandsFormat(
                                        totalVoucherAmount,
                                        2,
                                        ""
                                    )
                                )
                            ]);
                        }
                    },
                    {
                        title: "退货金额",
                        key: "refundTotalVal",
                        align: "center",
                        render: (h, params) => {
                            const refundTotalVal = params.row.refundTotalVal
                                ? params.row.refundTotalVal
                                : 0;
                            return h("div", {}, [
                                h(
                                    "span",
                                    {},
                                    number2ThousandsFormat(
                                        refundTotalVal,
                                        2,
                                        ""
                                    )
                                )
                            ]);
                        }
                    },
                    {
                        title: "有效金额",
                        key: "saleRealValue",
                        align: "center",
                        render: (h, params) => {
                            const saleRealValue = params.row.saleRealValue
                                ? params.row.saleRealValue
                                : 0;
                            return h("div", {}, [
                                h(
                                    "span",
                                    {},
                                    number2ThousandsFormat(saleRealValue, 2, "")
                                )
                            ]);
                        }
                    },
                    {
                        title: "均价",
                        key: "avgPrice",
                        align: "center",
                        render: (h, params) => {
                            const avgPrice = params.row.avgPrice || 0;
                            return h("div", {}, [
                                h(
                                    "span",
                                    {},
                                    number2ThousandsFormat(avgPrice, 2, "")
                                )
                            ]);
                        }
                    },
                    {
                        title: "销售定金",
                        key: "combinDeposit",
                        align: "center",
                        render: (h, params) => {
                            const combinDeposit = params.row.combinDeposit
                                ? params.row.combinDeposit
                                : 0;
                            return h("div", {}, [
                                h(
                                    "span",
                                    {},
                                    number2ThousandsFormat(combinDeposit, 2, "")
                                )
                            ]);
                        }
                    },
                    {
                        title: "客户经理提成",
                        key: "commissionValue",
                        align: "center",
                        render: (h, params) => {
                            const commissionValue = params.row.commissionValue
                                ? params.row.commissionValue
                                : 0;
                            return h("div", {}, [
                                h(
                                    "span",
                                    {},
                                    number2ThousandsFormat(
                                        commissionValue,
                                        2,
                                        ""
                                    )
                                )
                            ]);
                        }
                    },
                    {
                        title: "操作",
                        key: "action",
                        align: "center",
                        width: 250,
                        render: (h, params) => {
                            if (params.row.action === -1) {
                                return "";
                            }
                            else {
                                return h("div", [
                                    h(
                                        "Button",
                                        {
                                            props: {
                                                type: "text",
                                                size: "small",
                                                shape: "circle"
                                            },
                                            on: {
                                                click: () => {
                                                    this.showCombineStatDetail(
                                                        params.row.uuid
                                                    );
                                                }
                                            }
                                        },
                                        "查看明细"
                                    )
                                ]);
                            }
                        }
                    }
                ];
            }
            else {
                this.mainTable.statColumns = [
                    { title: "统计项", key: "groupName", align: "center" },
                    {
                        title: "本批发货量",
                        key: "preSaleCount",
                        align: "center"
                    },
                    {
                        title: "实际发货量",
                        key: "totalReceiveCount",
                        align: "center"
                    },
                    {
                        title: "销售金额",
                        key: "preSaleValue",
                        align: "center",
                        width: 120,
                        render: (h, params) => {
                            const preSaleValue = params.row.preSaleValue
                                ? params.row.preSaleValue
                                : 0;
                            return h("div", {}, [
                                h(
                                    "span",
                                    {},
                                    number2ThousandsFormat(preSaleValue, 2, "")
                                )
                            ]);
                        }
                    },
                    {
                        title: "优惠金额",
                        key: "saleDiscountValue",
                        align: "center",
                        render: (h, params) => {
                            const saleDiscountValue = params.row
                                .saleDiscountValue
                                ? params.row.saleDiscountValue
                                : 0;
                            return h("div", {}, [
                                h(
                                    "span",
                                    {},
                                    number2ThousandsFormat(
                                        saleDiscountValue,
                                        2,
                                        ""
                                    )
                                )
                            ]);
                        }
                    },
                    {
                        title: "代金券",
                        key: "totalVoucherAmount",
                        align: "center",
                        render: (h, params) => {
                            const totalVoucherAmount = params.row.totalVoucherAmount
                                ? params.row.totalVoucherAmount
                                : 0;
                            return h("div", {}, [
                                h(
                                    "span",
                                    {},
                                    number2ThousandsFormat(
                                        totalVoucherAmount,
                                        2,
                                        ""
                                    )
                                )
                            ]);
                        }
                    },
                    {
                        title: "退货金额",
                        key: "refundTotalVal",
                        align: "center",
                        render: (h, params) => {
                            const refundTotalVal = params.row.refundTotalVal
                                ? params.row.refundTotalVal
                                : 0;
                            return h("div", {}, [
                                h(
                                    "span",
                                    {},
                                    number2ThousandsFormat(
                                        refundTotalVal,
                                        2,
                                        ""
                                    )
                                )
                            ]);
                        }
                    },
                    {
                        title: "有效金额",
                        key: "saleRealValue",
                        align: "center",
                        render: (h, params) => {
                            const saleRealValue = params.row.saleRealValue
                                ? params.row.saleRealValue
                                : 0;
                            return h("div", {}, [
                                h(
                                    "span",
                                    {},
                                    number2ThousandsFormat(saleRealValue, 2, "")
                                )
                            ]);
                        }
                    },
                    {
                        title: "均价",
                        key: "avgPrice",
                        align: "center",
                        render: (h, params) => {
                            const avgPrice = params.row.avgPrice || 0;
                            return h("div", {}, [
                                h(
                                    "span",
                                    {},
                                    number2ThousandsFormat(avgPrice, 2, "")
                                )
                            ]);
                        }
                    },
                    {
                        title: "销售定金",
                        key: "combinDeposit",
                        align: "center",
                        render: (h, params) => {
                            const combinDeposit = params.row.combinDeposit
                                ? params.row.combinDeposit
                                : 0;
                            return h("div", {}, [
                                h(
                                    "span",
                                    {},
                                    number2ThousandsFormat(combinDeposit, 2, "")
                                )
                            ]);
                        }
                    },
                    {
                        title: "客户经理提成",
                        key: "commissionValue",
                        align: "center",
                        render: (h, params) => {
                            const commissionValue = params.row.commissionValue
                                ? params.row.commissionValue
                                : 0;
                            return h("div", {}, [
                                h(
                                    "span",
                                    {},
                                    number2ThousandsFormat(
                                        commissionValue,
                                        2,
                                        ""
                                    )
                                )
                            ]);
                        }
                    },
                    {
                        title: "操作",
                        key: "action",
                        align: "center",
                        width: 250,
                        render: (h, params) => {
                            if (params.row.action === -1) {
                                return "";
                            }
                            else {
                                return h("div", [
                                    h(
                                        "Button",
                                        {
                                            props: {
                                                type: "text",
                                                size: "small",
                                                shape: "circle"
                                            },
                                            on: {
                                                click: () => {
                                                    this.showCombineStatDetail(
                                                        params.row.uuid
                                                    );
                                                }
                                            }
                                        },
                                        "查看明细"
                                    )
                                ]);
                            }
                        }
                    }
                ];
            }
        },
        reSetsearchForm() {
            let userPersonNameValue = this.getSearchFormValue("userPersonName");
            let seedFarmNameValue = this.getSearchFormValue("seedFarmName");
            let distributionStationNameValue = this.getSearchFormValue(
                "distributionStationName"
            );
            let userCustomerManagerNameValue = this.getSearchFormValue(
                "userCustomerManagerName"
            );
            let mainCategoryNameValue
                = this.getSearchFormValue("mainCategoryName");
            let subCategoryNameValue
                = this.getSearchFormValue("subCategoryName");
            let productNameValue = this.getSearchFormValue("productName");

            if (
                this.groupBy == "product"
                || this.groupBy == "mainCate"
                || this.groupBy == "subCate"
            ) {
                this.mainTable.searchForm = [
                    {
                        label: "会员",
                        type: "Input",
                        value: userPersonNameValue,
                        name: "userPersonName",
                        sql: "like"
                    },
                    {
                        label: "苗场",
                        type: "Input",
                        value: seedFarmNameValue,
                        name: "seedFarmName",
                        sql: "like"
                    },
                    {
                        label: "大类",
                        type: "Input",
                        value: mainCategoryNameValue,
                        name: "mainCategoryName",
                        sql: "like"
                    },
                    {
                        label: "小类",
                        type: "Input",
                        value: subCategoryNameValue,
                        name: "subCategoryName",
                        sql: "like"
                    },
                    {
                        label: "转运站",
                        type: "Input",
                        value: distributionStationNameValue,
                        name: "distributionStationName",
                        sql: "like"
                    },
                    {
                        label: "客户经理",
                        type: "Input",
                        value: userCustomerManagerNameValue,
                        name: "userCustomerManagerName",
                        sql: "like"
                    },
                    {
                        label: "商品信息",
                        type: "Input",
                        value: productNameValue,
                        name: "productName",
                        sql: "like"
                    }
                ];
            }
            else {
                this.mainTable.searchForm = [
                    {
                        label: "会员",
                        type: "Input",
                        value: userPersonNameValue,
                        name: "userPersonName",
                        sql: "like"
                    },
                    {
                        label: "苗场",
                        type: "Input",
                        value: seedFarmNameValue,
                        name: "seedFarmName",
                        sql: "like"
                    },
                    {
                        label: "转运站",
                        type: "Input",
                        value: distributionStationNameValue,
                        name: "distributionStationName",
                        sql: "like"
                    },
                    {
                        label: "客户经理",
                        type: "Input",
                        value: userCustomerManagerNameValue,
                        name: "userCustomerManagerName",
                        sql: "like"
                    }
                ];
            }
        },
        getSearchFormValue(name) {
            let search = this.mainTable.searchForm.find((x) => x.name == name);
            if (!search) {
                return "";
            }
            return search.value;
        },
        getTodayDateString,
        getThisMonthStart,
        cancal() {
            this.combineStatDetail.tableSearch.limit.conditions.pageStart = 1;
            this.combineStatDetail.tableSearch.limit.conditions.pageLength = 10;
            this.combineStatDetail.show = false;
        },
        init() {
            this.getSaleStatList();
        },
        onSaleChage(e) {
            this.getSaleStatList(true);
        },
        onUserTypeChange(e) {
            this.getSaleStatList();
        },
        onTotalOrderCostChange(e) {
            this.getSaleStatList();
        },
        onGroupByChange(e) {
            this.mainTable.tableSearch.filters.conditions = [];
            this.combineStatDetail.tableSearch.filters.conditions = [];
            this.getSaleStatList();
        },
        onDateChange() {
            this.getSaleStatList();
        },
        /**
         * 处理标签点击事件
         * @param {string} tagType - 标签类型
         */
        handleTagClick(tagKey) {
            if (!this.tagTypes[tagKey]) return;
            // 切换输入框显示状态
            this.$set(this.tagTypes[tagKey], 'showInput', !this.tagTypes[tagKey].showInput);
            if (this.tagTypes[tagKey].showInput) {
                this.$nextTick(() => {
                    const inputElement = document.querySelector(`input[placeholder="${this.tagTypes[tagKey].placeholder}"]`);
                    if (inputElement) {
                        inputElement.focus();
                    }
                });
            }
        },


        /**
         * 处理输入框失焦事件
         * @param {string} tagType - 标签类型
         */
        handleInputBlur(tagKey) {
            if (!this.tagTypes[tagKey]) return;
            const inputValue = this.tagTypes[tagKey].value.trim();
            if (inputValue) {
                this.addFilterTagFromStatus(tagKey);
            }
            else {
                this.$set(this.tagTypes[tagKey], 'showInput', false);
            }
        },

        /**
         * 处理CustomTag组件的输入框失焦事件
         * @param {string} tagKey - 标签类型
         * @param {string} value - 输入值
         */
        handleTagInputBlur(tagKey, value) {
            if (!this.tagTypes[tagKey]) return;
            this.$set(this.tagTypes[tagKey], 'value', value);
            const inputValue = value.trim();
            if (inputValue) {
                // 格式化搜索结果并更新到searchValue字段
                const tagInfo = this.tagTypes[tagKey];
                const formattedValue = `${tagInfo.label}:${inputValue}`;
                this.$set(this.tagTypes[tagKey], 'searchValue', formattedValue);
                // 调用原有的搜索逻辑
                this.addFilterTagFromStatus(tagKey);
            }
            else {
                this.$set(this.tagTypes[tagKey], 'showInput', false);
                // 清空searchValue
                this.$set(this.tagTypes[tagKey], 'searchValue', '');
            }
        },

        /**
         * 从标签状态中添加筛选条件
         * @param {string} tagType - 标签类型
         */
        addFilterTagFromStatus(tagKey) {
            const tagInfo = this.tagTypes[tagKey];
            if (!tagInfo) return;
            const inputValue = tagInfo.value.trim();
            if (!inputValue) return;

            // 检查是否已存在相同的标签
            const existingTag = this.filterTags.find(
                tag => tag.key === tagKey && tag.value === inputValue
            );
            if (existingTag) {
                this.$Message.warning('该标签已存在');
                this.$set(this.tagTypes[tagKey], 'showInput', false);
                return;
            }

            // 对于下拉框模式，获取对应的显示名称
            let displayValue = inputValue;
            if (tagInfo.mode === 'select' && Array.isArray(tagInfo.options)) {
                const selectedOption = tagInfo.options.find(option =>
                    String(option.value) === String(inputValue)
                );
                if (selectedOption) {
                    displayValue = selectedOption.label;
                }
            }

            // 添加新的筛选标签
            const newTag = {
                key: tagKey,
                label: tagInfo.label,
                value: inputValue,
                displayValue: displayValue // 添加显示值
            };
            this.filterTags.push(newTag);

            // 更新searchValue以显示正确的格式
            const formattedSearchValue = `${tagInfo.label}:${displayValue}`;
            this.$set(this.tagTypes[tagKey], 'searchValue', formattedSearchValue);
            this.$set(this.tagTypes[tagKey], 'showInput', false);

            this.$Message.success(`已添加${tagInfo.label}标签`);
            setTimeout(() => {
                this.getSaleStatList();
            }, 300);
        },
        onRemoveTag(index) {
            const removedTag = this.filterTags[index];
            this.filterTags.splice(index, 1);

            // 清理tagTypes中对应的值
            if (removedTag && this.tagTypes[removedTag.key]) {
                this.$set(this.tagTypes[removedTag.key], 'value', '');
                this.$set(this.tagTypes[removedTag.key], 'searchValue', '');
                this.$set(this.tagTypes[removedTag.key], 'showInput', false);
            }

            this.$Message.success(`已删除${removedTag.label}标签`);
            this.getSaleStatList();
        },
        onRemoveTagByKey(tagKey) {
            // 通过tagKey移除filterTags和tagTypes
            const idx = this.filterTags.findIndex(tag => tag.key === tagKey);
            if (idx !== -1) {
                this.onRemoveTag(idx);
            }
            else if (this.tagTypes[tagKey]) {
                // 清除所有相关字段，恢复原始状态
                this.$set(this.tagTypes[tagKey], 'value', '');
                this.$set(this.tagTypes[tagKey], 'searchValue', '');
                this.$set(this.tagTypes[tagKey], 'showInput', false);
                // 提供用户反馈
                const tagInfo = this.tagTypes[tagKey];
                this.$Message.success(`已清除${tagInfo.label}标签`);
                // 重新加载数据
                this.getSaleStatList();
            }
        },
        onClearAllTags() {
            this.$Modal.confirm({
                title: "确认清空",
                content: "确定要清空所有标签吗？",
                onOk: () => {
                    this.filterTags = [];
                    // 重置所有标签状态
                    Object.keys(this.tagTypes).forEach(tagKey => {
                        this.$set(this.tagTypes[tagKey], 'selected', false);
                        this.$set(this.tagTypes[tagKey], 'showInput', false);
                        this.$set(this.tagTypes[tagKey], 'value', '');
                        this.$set(this.tagTypes[tagKey], 'searchValue', '');
                        this.$set(this.tagTypes[tagKey], 'mode', 'input');
                    });
                    this.getSaleStatList();
                    this.$Message.success("标签已清空");
                },
                onCancel: () => {
                    // 用户取消操作
                }
            });
        },
        updateTagFilters() {
            // 更新筛选条件，触发数据重新加载
            this.getSaleStatList();
        },
        /**
         * 添加标签筛选条件到搜索参数
         * 支持filterTags和tagTypes两种数据结构
         */
        addTagFilters() {
            // 清除filterTags中的筛选条件
            this.filterTags.forEach(tag => {
                search.globalRemoveFilterConditionKey(
                    this.mainTable.tableSearch,
                    tag.key
                );
            });

            // 清除tagTypes中的筛选条件
            Object.keys(this.tagTypes).forEach(tagKey => {
                search.globalRemoveFilterConditionKey(
                    this.mainTable.tableSearch,
                    tagKey
                );
            });

            // 添加filterTags中的筛选条件（兼容旧的功能）
            if (this.filterTags.length > 0) {
                this.mainTable.tableSearch.filters.enable = true;
                this.filterTags.forEach(tag => {
                    this.mainTable.tableSearch.filters.conditions.push({
                        name: tag.key,
                        type: "like",
                        value: tag.value
                    });
                });
            }

            // 添加tagTypes中的筛选条件（新的功能）
            const hasTagTypeFilters = Object.values(this.tagTypes).some(
                status => status.value && status.value.trim()
            );

            if (hasTagTypeFilters) {
                this.mainTable.tableSearch.filters.enable = true;
                Object.keys(this.tagTypes).forEach(tagKey => {
                    const tagType = this.tagTypes[tagKey];
                    if (tagType.value && tagType.value.trim()) {
                        this.mainTable.tableSearch.filters.conditions.push({
                            name: tagKey,
                            type: "like",
                            value: tagType.value.trim()
                        });
                    }
                });
            }
        },
        getAllRegionList() {
            getRegionCascade().then((res) => {
                if (res.code === 0) {
                    let find = this.mainTable.searchForm.find(
                        (item) => item.name === "memberDeliveryAddressDistUuid"
                    );
                    if (find) {
                        find.cascaderData = res.data.regionCascader;
                    }
                }
            });
        },
        onExport() {
            this.mainTable.loading = true;
            this.mainTable.tableSearch.limit.enable = false;
            this.mainTable.tableSearch.needExport = 1;
            this.mainTable.tableSearch.groupBy = this.groupBy;
            this.mainTable.tableSearch.beginDate = this.selectDates[0];
            this.mainTable.tableSearch.endDate = this.selectDates[1];
            this.mainTable.tableSearch.totalOrderCost = this.totalOrderCost;
            if (this.userType) {
                search.globalRemoveFilterConditionKey(
                    this.mainTable.tableSearch,
                    "memberType"
                );
                this.mainTable.tableSearch.filters.enable = true;
                this.mainTable.tableSearch.filters.conditions.push({
                    name: "memberType",
                    type: "eq",
                    value: this.userType
                });
            }
            getCombineSaleStat(this.mainTable.tableSearch).then((res) => {
                if (res.code === 0) {
                    if (res.code === 0) {
                        let url = DOWNLOAD_SERVER + res.data.exportFileName;
                        this.$downLoadFile(url);
                    }
                }
                this.mainTable.loading = false;
            });
        },
        onDetailExport() {
            this.combineStatDetail.tableSearch = search.deepClone(
                this.mainTable.tableSearch
            );
            search.globalRemoveFilterConditionKey(
                this.combineStatDetail.tableSearch,
                "memberType"
            );
            this.combineStatDetail.tableSearch.filters.enable = true;
            this.combineStatDetail.tableSearch.filters.conditions.push({
                name: "memberType",
                type: "eq",
                value: this.userType
            });
            this.combineStatDetail.tableSearch.totalOrderCost
                = this.totalOrderCost;
            this.combineStatDetail.tableSearch.limit.enable = false;
            this.combineStatDetail.tableSearch.uuid
                = this.combineStatDetail.uuid;
            this.combineStatDetail.tableSearch.showZeroPriceOnly
                = this.combineStatDetail.showZeroPriceOnly;

            this.combineStatDetail.tableSearch.excelExport.enable = true;

            this.combineStatDetail.tableSearch.excelExport.columns2
                = this.combineStatDetail.preSaleColumns
                    .filter((col) => col.excel)
                    .map((col) => {
                        return {
                            key: col.key,
                            title: col.title
                        };
                    });

            this.combineStatDetail.loading = true;
            getCombineSaleStatDetail(this.combineStatDetail.tableSearch).then(
                (res) => {
                    this.combineStatDetail.loading = false;
                    if (res.code === 0) {
                        let url = DOWNLOAD_SERVER + res.data.exportFileName2;
                        this.$downLoadFile(url);
                    }
                }
            );
        },
        onshowZeroPrice() {
            this.showCombineStatDetail(this.combineStatDetail.uuid);
        },
        showCombineStatDetail(uuid) {
            this.combineStatDetail.tableSearch.filters.conditions = [];
            //将主列表的搜索条件遍历赋值给明细列表，成为明细列表的搜索条件
            this.mainTable.tableSearch.filters.conditions.forEach((item) => {
                search.globalRemoveFilterConditionKey(
                    this.combineStatDetail.tableSearch,
                    item.name
                );
                this.combineStatDetail.tableSearch.filters.enable = true;
                this.combineStatDetail.tableSearch.filters.conditions.push({
                    name: item.name,
                    type: "eq",
                    value: item.value
                });
            });
            this.combineStatDetail.tableSearch.groupBy = this.groupBy;
            this.combineStatDetail.tableSearch.beginDate = this.selectDates[0];
            this.combineStatDetail.tableSearch.endDate = this.selectDates[1];
            this.combineStatDetail.tableSearch.showZeroPriceOnly = this.combineStatDetail.showZeroPriceOnly;
            this.combineStatDetail.tableSearch.showZeroPriceOnly = this.totalOrderCost == 1 ? true : false;
            this.combineStatDetail.tableSearch.excelExport.enable = false;
            if (uuid) {
                this.combineStatDetail.tableSearch.uuid = uuid;
                this.combineStatDetail.uuid = uuid;
            }
            else {
                this.combineStatDetail.tableSearch.uuid
                    = this.combineStatDetail.uuid;
            }

            this.combineStatDetail.show = true;
            this.combineStatDetail.loading = true;
            getCombineSaleStatDetail(this.combineStatDetail.tableSearch).then(
                (res) => {
                    this.combineStatDetail.loading = false;
                    if (res.code === 0) {
                        this.combineStatDetail.preSaleData = res.data.listCombine;
                        let totalCount = 0;
                        let totalReceiveCount = 0;
                        let totalValue = 0;
                        let saleDiscountValueAll = 0;
                        let refundTotalValAll = 0;
                        let saleRealValueAll = 0;
                        let totalVoucherAmount = 0;
                        let depositBillDetailsalesAssociateCommissionValue = 0;
                        this.combineStatDetail.preSaleData.forEach((e) => {
                            totalCount = this.preciseAdd(totalCount, e.preSaleDeliveryDetailQuantity);
                            totalReceiveCount = this.preciseAdd(totalReceiveCount, e.receiveQuantity);
                            totalValue = this.preciseAdd(totalValue, e.preSaleDeliveryDetailActProductCost);
                            saleDiscountValueAll = this.preciseAdd(saleDiscountValueAll, e.saleDiscountValue);
                            refundTotalValAll = this.preciseAdd(refundTotalValAll, e.refundTotalVal);
                            saleRealValueAll = this.preciseAdd(saleRealValueAll, e.saleRealValue);
                            totalVoucherAmount = this.preciseAdd(totalVoucherAmount, e.voucherAmount);
                            depositBillDetailsalesAssociateCommissionValue = this.preciseAdd(
                                depositBillDetailsalesAssociateCommissionValue,
                                e.depositBillDetailsalesAssociateCommissionValue
                            );
                        });
                        this.combineStatDetail.preSaleData.push({
                            preSaleDeliveryDetailQuantity: numberToFixed(
                                totalCount,
                                2
                            ),
                            receiveQuantity: numberToFixed(
                                totalReceiveCount,
                                2
                            ),
                            avgPrice: numberToFixed(totalReceiveCount==0 ? 0 : (saleRealValueAll / totalReceiveCount).toFixed(2), 2),
                            preSaleDeliveryDetailActProductCost: numberToFixed(
                                totalValue,
                                2
                            ),
                            saleDiscountValue: numberToFixed(
                                saleDiscountValueAll,
                                2
                            ),
                            refundTotalVal: numberToFixed(refundTotalValAll, 2),
                            saleRealValue: numberToFixed(saleRealValueAll, 2),
                            voucherAmount: numberToFixed(totalVoucherAmount, 2),
                            depositBillDetailsalesAssociateCommissionValue:
                                numberToFixed(
                                    depositBillDetailsalesAssociateCommissionValue,
                                    2
                                ),
                            depositBillRecordCode: "合计"
                        });
                        search.globalSetFilterRecordCount(
                            this.combineStatDetail.tableSearch,
                            res.data.filterRecordCount
                        );
                    }
                }
            );
        },

        getSaleStatList(reset = false) {
            this.reSetColumns();
            this.reSetsearchForm();
            search.globalSetFilterWithSearchForm(
                this.mainTable.tableSearch,
                search.filterForm(this.mainTable.searchForm)
            );
            this.mainTable.loading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }

            if (this.userType) {
                search.globalRemoveFilterConditionKey(
                    this.mainTable.tableSearch,
                    "memberType"
                );
                this.mainTable.tableSearch.filters.enable = true;
                this.mainTable.tableSearch.filters.conditions.push({
                    name: "memberType",
                    type: "eq",
                    value: this.userType
                });
            }

            // 添加标签筛选条件
            this.addTagFilters();
            console.log("this.totalOrderCost", this.totalOrderCost);
            this.mainTable.tableSearch.totalOrderCost = this.totalOrderCost;
            this.mainTable.tableSearch.limit.enable = false;
            this.mainTable.tableSearch.needExport = 0;
            this.mainTable.tableSearch.groupBy = this.groupBy;
            this.mainTable.tableSearch.beginDate = this.selectDates[0];
            this.mainTable.tableSearch.endDate = this.selectDates[1];
            getCombineSaleStat(this.mainTable.tableSearch)
                .then((res) => {
                    this.mainTable.loading = false;
                    this.mainTable.sarchCardShow = false;
                    if (res.code === 0) {
                        this.mainTable.data = res.data.listCombine;
                        let preSaleValueAll = 0;
                        let preSaleCountAll = 0;
                        let totalReceiveCountAll = 0;
                        let combinDepositAll = 0;
                        let saleDiscountValueAll = 0;
                        let refundTotalValAll = 0;
                        let saleRealValueAll = 0;
                        let commissionValueAll = 0;
                        let avgPriceAll = 0;
                        let totalVoucherAmountAll = 0;
                        this.mainTable.data.forEach((e) => {
                            preSaleValueAll = this.preciseAdd(preSaleValueAll, e.preSaleValue);
                            preSaleCountAll = this.preciseAdd(preSaleCountAll, e.preSaleCount);
                            totalReceiveCountAll = this.preciseAdd(totalReceiveCountAll, e.totalReceiveCount);
                            combinDepositAll = this.preciseAdd(combinDepositAll, e.combinDeposit);
                            saleDiscountValueAll = this.preciseAdd(saleDiscountValueAll, e.saleDiscountValue);
                            refundTotalValAll = this.preciseAdd(refundTotalValAll, e.refundTotalVal);
                            saleRealValueAll = this.preciseAdd(saleRealValueAll, e.saleRealValue);
                            commissionValueAll = this.preciseAdd(commissionValueAll, e.commissionValue);
                            avgPriceAll = this.preciseAdd(avgPriceAll, e.avgPrice);
                            totalVoucherAmountAll = this.preciseAdd(totalVoucherAmountAll, e.totalVoucherAmount);
                        });
                        this.mainTable.data.push({
                            preSaleValue: numberToFixed(preSaleValueAll, 2),
                            preSaleCount: numberToFixed(preSaleCountAll, 2),
                            totalReceiveCount: numberToFixed(
                                totalReceiveCountAll,
                                2
                            ),
                            combinDeposit: numberToFixed(combinDepositAll, 2),
                            saleDiscountValue: numberToFixed(
                                saleDiscountValueAll,
                                2
                            ),
                            refundTotalVal: numberToFixed(refundTotalValAll, 2),
                            saleRealValue: numberToFixed(saleRealValueAll, 2),
                            avgPrice: numberToFixed(avgPriceAll, 2),
                            totalVoucherAmount: numberToFixed(totalVoucherAmountAll, 2),
                            commissionValue: numberToFixed(
                                commissionValueAll,
                                2
                            ),
                            groupName: "合计",
                            action: -1
                        });
                    }
                })
                .catch(() => {
                    this.mainTable.loading = false;
                });
        }
    }
};
</script>

<style scoped>
.div-header {
    display: flex;
    justify-content: flex-end;
}
.div-header .btn-font {
    font-size: 18px;
    line-height: 0 !important;
}
.global-tool-bar .left-bar {
    height: 60px !important;
}
.global-tool-bar .right-bar {
    height: 60px !important;
}
.global-tool-bar .left-bar .title {
    width: 140px !important;
    margin: 0 15px 0 5px !important;
}
.ivu-radio-group-button.ivu-radio-group-small .ivu-radio-wrapper {
    padding: 0px 5px !important;
}

/* 标签筛选样式优化 */
.tag-filter-container {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    align-items: center;
    margin-top: 15px;
    margin-left: 10px;
    padding: 12px 16px;
    background-color: #fafafa;
    border-radius: 8px;
    border: 1px solid #e8eaec;
    transition: all 0.3s ease;
}

.tag-filter-container:hover {
    border-color: #dcdee2;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.tag-filter-item {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    position: relative;
}

.tag-filter-item:hover::before {
    content: '';
    position: absolute;
    top: -4px;
    left: -4px;
    right: -4px;
    bottom: -4px;
    border-radius: 6px;
    background-color: rgba(45, 140, 240, 0.05);
    z-index: -1;
}

.tag-filter-item .ivu-tag {
    cursor: pointer;
    margin-right: 5px;
    transition: all 0.3s ease;
    user-select: none;
    border-radius: 4px;
    padding: 4px 8px;
    font-size: 12px;
    border: 1px solid #e8eaec;
}

.tag-filter-item .ivu-tag:hover {
    border-color: #2d8cf0;
    color: #2d8cf0;
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(45, 140, 240, 0.2);
}

.tag-filter-item .ivu-tag.ivu-tag-primary {
    background-color: #2d8cf0;
    border-color: #2d8cf0;
    color: #fff;
    font-weight: 500;
}

.tag-filter-item .ivu-tag.ivu-tag-primary:hover {
    background-color: #57a3f1;
    border-color: #57a3f1;
    color: #fff;
}

.tag-filter-item .ivu-input-wrapper {
    margin-right: 5px;
}

.tag-filter-item .ivu-input {
    border-radius: 4px;
    transition: all 0.3s ease;
}

.tag-filter-item .ivu-input:focus {
    border-color: #2d8cf0;
    box-shadow: 0 0 0 2px rgba(45, 140, 240, 0.2);
}

.clear-tags-btn {
    margin-left: 10px;
    transition: all 0.3s ease;
}

.clear-tags-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(255, 152, 0, 0.3);
}

/* 响应式设计 */
@media (max-width: 768px) {
    .tag-filter-container {
        margin-left: 5px;
        gap: 6px;
    }

    .tag-filter-item .ivu-tag {
        font-size: 11px;
        padding: 3px 6px;
    }

    .tag-filter-item .ivu-input {
        width: 120px !important;
    }
}

/* 动画效果 */
@keyframes tagPulse {
    0% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.05);
    }
    100% {
        transform: scale(1);
    }
}

.tag-filter-item .ivu-tag.ivu-tag-primary {
    animation: tagPulse 0.3s ease-in-out;
}

/* 已添加标签样式 */
.filter-tags-container {
    margin-top: 15px;
    margin-left: 10px;
    padding: 12px 16px;
    background-color: #fafafa;
    border-radius: 8px;
    border: 1px solid #e8eaec;
    transition: all 0.3s ease;
    min-height: 20px;
}

.filter-tags-container:hover {
    border-color: #dcdee2;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.filter-tags-container .ivu-tag {
    margin-right: 10px;
    margin-bottom: 8px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    border-radius: 4px;
    padding: 4px 8px;
    font-size: 12px;
}

.filter-tags-container .ivu-tag:hover {
    transform: translateY(-1px) scale(1.02);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    border-color: #2d8cf0;
    color: #2d8cf0;
}

.filter-tags-container .ivu-tag.ivu-tag-color-primary {
    background-color: #2d8cf0;
    border-color: #2d8cf0;
    color: #fff;
}

.filter-tags-container .ivu-tag.ivu-tag-color-primary:hover {
    background-color: #57a3f1;
    border-color: #57a3f1;
    color: #fff;
}
</style>
